import WidgetContainer from "./WidgetContainer";
// TODO: Replace this temporary SVG with the ChirpIllustration once Chirp provides one with the colors built in.
import ManagePetIcon from './assets/manage-pet-add.svg';
import ActionButton from "./ActionButton";
import { ActionDef } from '@chewy/chat-library-common';

import styles from './AddPetCard.module.scss';
export default function AddPetCard({ action, widgetData }: { action: ActionDef; widgetData?: Record<string, any> }) {
    return (
        <WidgetContainer isSelectable={false} hasActions containerStyle={{ width: '254px', maxWidth: '100%' }}>
            <div className={styles.container}>
                <ManagePetIcon aria-label="Add a pet" role="img" width="189" height="124" />
                <ActionButton action={action} widgetData={widgetData} />
            </div>
        </WidgetContainer>
    );
}
